import { IClient } from '@splitsoftware/splitio/types/splitio';
import { createContext } from 'react';

export type FeatureFlagsContextProps = {
    client: IClient;
};

const FeatureFlagsContext = createContext<FeatureFlagsContextProps>({
    client: null,
});

export default FeatureFlagsContext;
